import * as React from "react";

export default class Box extends React.PureComponent<{ style?: React.CSSProperties, padding?: number, className?: string, noBox?: boolean, borderColor?: string }> {
    public render() {
        const { padding, className, noBox, borderColor } = this.props
        return <div className={(!noBox ? 'box ' : '') + (className || '')} style={Object.assign(padding ? { padding } : {}, this.props.style, { borderColor: borderColor })}>
            {this.props.children}
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/Box.tsx